var map = {
	"./new1.jpeg": "1fc5",
	"./new10.jpg": "bcbf",
	"./new11.jpg": "2374",
	"./new12.jpg": "98e1",
	"./new13.jpg": "28ca",
	"./new14.jpg": "f208",
	"./new15.jpg": "0b0c",
	"./new16.jpg": "915c",
	"./new17.jpg": "9a60",
	"./new18.jpg": "96df",
	"./new19.jpg": "df91",
	"./new3.jpg": "51d5",
	"./new5.jpg": "4bca",
	"./new6.jpg": "9725",
	"./new7.jpg": "4539",
	"./new8.jpg": "5e22",
	"./new9.jpg": "518c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1174";